export const requestId = '1699971141.054495831270118431';

export enum BrandStyle {
  classic = 'classic',
  notBranded = 'notBranded',
  wixel = 'wixel',
}
